/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTeamMemberNotificationSettings} from '../api'

export const useMutationUpdateTeamMemberNotificationSettings = createReactQueryMutationHook('updateTeamMemberNotificationSettings', updateTeamMemberNotificationSettings)
